export default {
    EXCELLENT: '5-excellent',
    VERY_GOOD: '4-very-good',
    GOOD: '3-good',
    FAIR: '2-fair',
    POOR: '1-poor',
    NONE: '0-no',
};
